<template>
  <b-modal
    :can-cancel="false"
    custom-class="modal-shadow"
    :active="active"
    width="416px"
  >
    <div
      class="
        tw-relative
        tw-flex
        tw-flex-col
        tw-items-center
        tw-gap-2
        tw-px-6
        tw-py-4
        tw-font-heading
        tw-bg-white
        tw-text-center
        tw-rounded-md
      "
    >
      <CloseIcon
        class="tw-block tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer"
        aria-role="button"
        aria-label="Close"
        @click="$emit('close')"
      ></CloseIcon>
      <h1
        class="
          tw-text-aubergine-950 tw-text-[28px]
          sm:tw-text-[32px]
          md:tw-text-[36px]
          tw-font-extrabold
        "
      >
        {{ $t('onboarding_modal_title') }}
      </h1>
      <p class="tw-text-[18px] lg:tw-text-[24px] tw-font-extrabold">
        {{ $t('onboarding_modal_subtitle') }}
      </p>
      <figure>
        <img
          class="tw-h-auto tw-max-w-full"
          src="/images/young_man_variant_1.png"
          :alt="$t('onboarding_modal_image_alt')"
        />
      </figure>
      <button
        class="
          tw-w-full
          tw-flex
          tw-items-center
          tw-gap-2
          tw-justify-center
          tw-bg-gradient-to-b
          tw-from-[#00B8C3]
          tw-to-[#034592]
          tw-text-white
          tw-font-semibold
          tw-py-3
          tw-px-6
          tw-rounded-md
          hover:tw-opacity-90
          tw-mt-8
          disabled:tw-opacity-50
          tw-shadow-button tw-border tw-border-black tw-font-heading
        "
        @click="$emit('close')"
      >
        {{ $t('onboarding_modal_button') }}
      </button>
    </div>
  </b-modal>
</template>
<script>
import CloseIcon from '@/assets/icons/close.svg?inline'
export default {
  components: { CloseIcon },
  model: {
    prop: 'active',
    event: 'close',
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="postcss" scoped>
.modal-shadow {
  @apply tw-px-4;
  & >>> .modal-content {
    @apply tw-rounded-md;
    @apply tw-border-2 tw-border-black;
    @apply tw-shadow-modal;
  }
}
</style>
